module.exports = __webpack_public_path__ + "static/Saale-Unstrut1-scaled-b4d958651612284532a3bc46e21777c4.jpeg";